async function fallbackCopyTextToClipboard(text: string) {
  const textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand("copy");
    // console.log("Fallback: Copying text command was " + msg);
    if (successful) return;
    throw Error(
      'Legacy copy to clipboard - Was unable to execute "copy" command',
    );
  } finally {
    document.body.removeChild(textArea);
  }
}

export function safeCopyToClipboard(text: string) {
  //if (!navigator.clipboard) {
  return fallbackCopyTextToClipboard(text);
  //}

  //return navigator.clipboard.writeText(text);
}
